/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts,updateCategory,setQuote,initQuote,uploadProducts, setCompanyLoaded} from '../actions/quote'
import Category from "./Category.js"
import { toast } from 'react-toastify';
import { Badge } from "reactstrap";
import OrderHeader from "./IndexSections/OrderHeader.js";
import { getDateTime } from "../common"
import Memo from "./IndexSections/Memo"
import { Editor } from '@tinymce/tinymce-react';

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import Product from "./IndexSections/Product.js";


function Index(props) {
  // const [state, setState] = useState([]);
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const main = useRef();
  const [noteModal, setNoteModal] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [customiseLogo, setCustomiseLogo] = useState(false);
  const [memoNote, setMemoNote] = useState("");
  const [newMemoNote, setNewMemoNote] = useState("");
  const [memos, setMemos] = useState([]);

  const toggleNote = () => setNoteModal(!noteModal);
  const toggleCustomiseLogo = () => setCustomiseLogo(!customiseLogo);
  const toggleAddProduct = () => {
    console.log("toggle");
    setOpenAddProduct(!openAddProduct);
  }

  useEffect(() => {
    props.initQuote()
    let { id } = props.match.params
    axios.get(`/quotes/edit/${id}`).then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success")
        var quote = res.data.data
        if(quote){
          var categories = JSON.parse(quote.content);
          for(var key in categories){
            var category = {...categories[key]};
            var items = category['items']
            var groups = category['groups']
            for(var loop = 0; loop < items.length; loop++){
              if(groups){
                var group = groups[loop]
                if("fee_price" in group){
                  group['fee_price'] = (group['fee_price']*1).toFixed(2)
                }
                else{
                  group['fee_price'] = (0).toFixed(2)
                }
                if("price" in group){
                  group['price'] = (group['price']*1).toFixed(2)
                }
                else{
                  group['price'] = (0).toFixed(2)
                }
                if("discount_price" in group){
                  group['discount_price'] = (group['discount_price']*1).toFixed(2)
                }
                else{
                  group['discount_price'] = (0).toFixed(2)
                }
                group.cost_visible = false
                items[loop]['group_options'] = group    
              }   
            }
            category['items'] = items;
            categories[key] = category;
          }
          setMemoNote(quote.memo_note)
          setCustomiseLogo(quote.customise_logo)

        }
    }) 
    setOrderId(id) 
  },[]);

  useEffect(() => {
    if(props.quote.companyLoaded){
      if(!props.quote.productUploaded)
        props.uploadProducts();
    }
  },[props.quote.companyLoaded]);

  const renderCategory=()=>{
    const quote = props.quote;
    const categories = quote.categories;
    var elements = [];
    var position = 0;
    for(var index in categories){
      const category = categories[index]
      elements.push(
        <Category history={props.history} key={index} position = {position} category={category.category_info} state={category.items} groups={category.groups} updateCategory={props.updateCategory}/>
      )
      position++;
      break;
    }
    return elements;
  }
  const submitOrder=async()=>{
    const {
      selectedContactUser,
      selectedContactAddress,
      selectedContactInfo,
      custom_address,
      logoImage,
      validDate,
      delivery_required,
      pickup_instore,
      collection_id
    } = props.quote;
    var quote = props.quote;
    var bodyFormData = new FormData();
    var categories = {...quote.categories};
    for(var key in categories){
      var category = {...categories[key]};
      var items = category['items']
      var groups = [];
      for(var loop = 0; loop < items.length; loop++){
        var groupOptions = items[loop]['group_options'];
        groups.push(groupOptions?groupOptions:{});
      }
      category['groups'] = groups;
      categories[key] = category;
    }
    bodyFormData.append('order_status', "Requested Order");
    bodyFormData.append('content', JSON.stringify(categories));
    bodyFormData.append('customise_logo',customiseLogo)
    bodyFormData.append('contact_user',selectedContactUser?selectedContactUser:'')
    bodyFormData.append('contact_address',selectedContactAddress?selectedContactAddress:'')
    bodyFormData.append('contact_info',selectedContactInfo?selectedContactInfo:'')
    bodyFormData.append('custom_address',custom_address?custom_address:'')
    bodyFormData.append('valid_to',validDate?validDate:"")
    bodyFormData.append('delivery_required',delivery_required?"1":"0")
    bodyFormData.append('pickup_instore',pickup_instore?"1":"0")
    bodyFormData.append('collection_id',collection_id?collection_id:'')
    bodyFormData.append('label',quote.quoteLabel?quote.quoteLabel:"")
    bodyFormData.append('client_label',quote.clientLabel?quote.clientLabel:"")
    bodyFormData.append('price',quote.totalPrice?quote.totalPrice:"")   
    bodyFormData.append('default_brand',quote.defaultBrand?quote.defaultBrand:"")    
    bodyFormData.append('wfm_order_no',quote.wfm_order_no?quote.wfm_order_no:"") 
    if(logoImage)
      bodyFormData.append('logo', logoImage);
 
    if(!delivery_required && !pickup_instore){
      toast.error('You must select a delivery preference. Please try again');
      return;
    }
    if((delivery_required || pickup_instore) && !collection_id){
      toast.error('You must select a collection contact. Please try again');
      return;
    }

    axios.post(`/quotes/edit/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("Your order has been submitted");
        props.history.push("/myorders")
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }
  const saveOrder=async()=>{
    const {
      selectedContactUser,
      selectedContactAddress,
      selectedContactInfo,
      custom_address,
      logoImage,
      validDate,
      delivery_required
    } = props.quote;
    var quote = props.quote;
    var bodyFormData = new FormData();
    var categories = {...quote.categories};
    for(var key in categories){
      var category = {...categories[key]};
      var items = category['items']
      var groups = [];
      for(var loop = 0; loop < items.length; loop++){
        var groupOptions = items[loop]['group_options'];
        groups.push(groupOptions?groupOptions:{});
      }
      category['groups'] = groups;
      categories[key] = category;
    }
    bodyFormData.append('content', JSON.stringify(categories));
    bodyFormData.append('customise_logo',customiseLogo)
    bodyFormData.append('contact_user',selectedContactUser?selectedContactUser:'')
    bodyFormData.append('contact_address',selectedContactAddress?selectedContactAddress:'')
    bodyFormData.append('contact_info',selectedContactInfo?selectedContactInfo:'')
    bodyFormData.append('custom_address',custom_address?custom_address:'')
    bodyFormData.append('valid_to',validDate?validDate:"")
    bodyFormData.append('delivery_required',delivery_required?"1":"0")
    bodyFormData.append('label',quote.quoteLabel?quote.quoteLabel:"")
    bodyFormData.append('price',quote.totalPrice?quote.totalPrice:"")    
    bodyFormData.append('client_label',quote.clientLabel?quote.clientLabel:"")
    bodyFormData.append('default_brand',quote.defaultBrand?quote.defaultBrand:"") 
    bodyFormData.append('wfm_order_no',quote.wfm_order_no?quote.wfm_order_no:"") 
    if(logoImage)
      bodyFormData.append('logo', logoImage);

    // if not selected contact user skip - mykhailo 2025.09.18
    if(!selectedContactUser){
      toast.error('You must select the contact user. Please try again');
      return;
    }
    
    axios.post(`/quotes/edit/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("Your order has been saved");
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }
  
  const repeatOrder=async()=>{
    // var quote = props.quote;
    // var bodyFormData = new FormData();    
    // axios.post(`/quotes/repeat/${orderId}`, bodyFormData).then(res => {
    //   const result = res.data;
    //   if(result.status == "success"){        
    //     toast.success("Your order has been copied");
    //     props.history.push("/myorders")
    //   }
    //   else{
    //     toast.error(result.data);
    //   }
    // }).catch(err => {
    //   toast.error('Something was wrong. Try again');
    // })
    props.history.push("/myorders")
  }

  const addMemo =async()=>{
    let userId = props.quote.user_id

    if(userId) {
      var bodyFormData = new FormData();
      bodyFormData.append('memo_note', newMemoNote);
      bodyFormData.append('user_to', userId);
      if(props.quote){
        axios.post(`/quotes/addcompanymemo`, bodyFormData).then(res => {
          const result = res.data;
          if(result.status == "success"){        
            getmemo();
            // setNoteModal(false)
          }
          else{
            toast.error(result.data);
          }
        }).catch(err => {
          toast.error('Something was wrong. Try again');
        })
      }
      else{
        toast.error('Quote is empty');
      }
    }
  }

  const uploadfile =async(e)=>{
    let userId = props.quote.user_id

    if(userId) {
      var bodyFormData = new FormData();
      bodyFormData.append('user_to', userId);
      bodyFormData.append('file', e.target.files[0]); 
      if(props.quote){
        axios.post(`/quotes/uploadmemofile`, bodyFormData).then(res => {
          console.log("UPLOAD FROM: EditOrder.js");
          const result = res.data;
          if(result.status == "success"){        
            getmemo();
            // setNoteModal(false)
          }
          else{
            toast.error(result.data);
          }
        }).catch(err => {
          toast.error('Something was wrong. Try again');
        })
      }
      else{
        toast.error('Quote is empty');
      }
    }
  }

  const getMemoCount = (memo)=>{
    if(!memo) return 0
    const  newstrings = memo.split("\n"); 
    return newstrings.length;
  }

  const getmemo=()=>{
    let userId = props.quote.user_id
    if(userId) {
      axios.get(`/quotes/getcompanymemo/${userId}`).then(res => {
        if(res.data.status == "success"){
          setMemos(res.data.data)
        }
      }) 
    }
  }

  const removememo = (id)=>{
    axios.get(`/quotes/removememo/${id}`).then(res => {
      if(res.data.status == "success"){
        getmemo()
      }
    }) 
  }

  return (
    <>
      <DemoNavbar />
      <main ref={main}>
        <Container fluid="lg" className="m-auto">
          <Row>
            <Col  md="12">                   
              <OrderHeader/>
              {
                renderCategory()
              }
              <div className="order-nav" style={{marginTop:'60px'}}>
                <div>
                  <Button
                    // onClick={() => {
                    //   setState([...state, []]);
                    // }}
                    onClick={toggleAddProduct}
                    className="btn-icon btn-3" color="primary" type="button">
                    <span className="btn-inner--text">ADD CATALOGUE</span>
                  </Button>                  
                  <Button
                    // onClick={() => {
                    //   setState([...state, []]);
                    // }}
                    color="white" outline
                    className="btn-icon btn-3" type="button">
                    <span className="btn-inner--icon">
                      <i className="fa fa-plus" aria-hidden="true"></i>
                    </span>
                    <span className="btn-inner--text">Add BRAND MANAGEMENT</span>
                  </Button>
                </div>
                <div>
                  <Button
                    onClick={()=>props.history.push("/requests/add?method=repeat")}
                    color="white" outline
                    className="btn-icon btn-3" type="button">
                    <span className="btn-inner--text">REPEAT ORDER</span>
                  </Button>
                  <Button
                    onClick={saveOrder}
                    color="white" outline
                    className="btn-icon btn-3" type="button">
                    <span className="btn-inner--text">SAVE ORDER</span>
                  </Button>
                  <Button
                    onClick={submitOrder}
                    className="btn-icon btn-3" color="primary" type="button">
                    <span className="btn-inner--text">SUBMIT ORDER</span>
                  </Button>   
                  <Button
                    onClick={()=>setNoteModal(true)}
                    className="btn-icon btn-3" color="primary" type="button">
                    <i style={{fontSize:20}} className="fa fa-commenting-o" aria-hidden="true"></i>
                      <Badge className="badge-white m-0">{getMemoCount(memoNote)}</Badge>
                  </Button>  
                </div>
              </div>
              {openAddProduct &&
              <Product isOpen={openAddProduct} category={null} toggle = {toggleAddProduct}
                onAdd={(items, categoryInfo) => {
                  var state=[]
                  var categories = {...props.quote.categories}
                  var category = null
                  for(var catInd in categories){
                    var category = {...categories[catInd]}
                    break;
                  }
                  if(category)
                    state = [...category.items]
                  var newitems = [...items]
                  for(var loop = 0; loop < newitems.length; loop++){
                    var newitem = {...newitems[loop]}
                    newitem['productid'] = newitem['id']
                    var itemCount = 0;
                    for(var loop1 = 0; loop1< state.length; loop1++){
                      itemCount+= state[loop1].length;
                    }
                    newitem['id'] = (loop + itemCount + 1).toString()
                    newitems[loop] = newitem
                  }
                  var newstate = [...state, newitems];
                  console.log("newstate", newstate)
                  // setState(newstate);
                  toggleAddProduct();
                  var cat_val={
                    [0]:{
                      category_info: categoryInfo,
                      items: newstate
                    }
                  }
                  props.updateCategory(cat_val)
                }}
              />
              }
            </Col>
          </Row>
          <Modal className="modal-lg conversation-log" isOpen={noteModal} toggle={toggleNote} size="lg">
            <ModalHeader toggle={toggleNote}>
              <h3 className="h4 font-weight-bold mb-0">
              Conversation Log
              </h3>
            </ModalHeader>
            <ModalBody>
                  <FormGroup>
                    <Memo memos = {memos} removememo = {removememo}/>
                  </FormGroup>
                  <FormGroup>
                  {/* <Input type="input" rows="" value={newMemoNote} onChange={(e)=>setNewMemoNote(e.target.value)} placeholder="Type here..."/> */}
                  <Editor
                    initialValue={''}
                    apiKey='tjdmpms7zl95nzbouj8gcxhkk9q122xd7fsce8wjk0hqwn8g'
                    init={{
                      plugins: 'link image code',
                      toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code',
                      content_style: "p { margin: 0 0 3px 0; }",
                    }}
                    onChange={(e)=>setNewMemoNote(e.target.getContent())}
                  />
                  
                  </FormGroup>
                  <div style={{display:'flex', justifyContent:'flex-end', padding:"0 20px"}}>
                    <Button className="" onClick={()=>{document.getElementById(`upload-file`).click();}}  color="primary" type="button">
                      Upload File
                    </Button>
                    <Button color="primary" onClick={()=>addMemo()}>Add</Button>{' '}
                    <Button color="secondary" onClick={toggleNote}>Close</Button>
                  </div>
                  <input type="file" id={`upload-file`} style={{display:'none'}} onChange={(e)=>uploadfile(e)}/>
            </ModalBody>            
          </Modal>
        </Container>
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    uploadProducts: ()=>dispatch(uploadProducts()),
    updateCategory: cat=>dispatch(updateCategory(cat)),
    setQuote: quote=>dispatch(setQuote(quote)),
    initQuote:()=>dispatch(initQuote()),
    setCompanyLoaded: value=>dispatch(setCompanyLoaded(value)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
